// src/lib/posthog/properties.ts
// `pickAllowed` enforces events.ts's per-event closed allowlist at the point
// every capture leaves the app: any key not declared for that event is
// dropped, never forwarded to PostHog.

import { EVENT_PROPERTIES, type EventName } from "./events";

// `$source` is not special-cased: only server events declare it, so a
// browser-supplied `$source` on a client event is dropped like any other
// unknown key. captureServer stamps it after this filter runs.

export function pickAllowed(
  event: EventName,
  props?: Record<string, unknown>,
): Record<string, unknown> {
  if (!props) return {};
  const allowed = new Set(EVENT_PROPERTIES[event]);
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (allowed.has(key)) {
      result[key] = value;
    }
  }
  return result;
}
